const config = {
    verifyCodeEndpoint: process.env.VERIFY_CODE_ENDPOINT || 'https://device-api.da.saeco.com/auth/verify_code'
};

export default config;